import { useState, useEffect, useRef, useReducer, createElement } from "react";
import DataTable from "react-data-table-component";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import { DATATABLE_CUSTOM_STYLES, DATATABLE_CUSTOM_STYLES_STATIC } from "Components/Datatable/DatatableComponents/DatatableCustomStyles"
import DatatablePagination from "Components/Datatable/DatatablePagination"
import DatatableNumEntriesField from "./DatatableComponents/DatatableNumEntriesField"
import { NO_DATA_FOUND_DESCRIPTION } from 'Utils/constants';
import DatatableSearchField from "./DatatableComponents/DatatableSearchField";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling'
import { useLocation, useNavigate } from 'react-router-dom';
import { isInObject } from "Utils/utilityFunctions";
import {store} from "Store";

// Datatable fileter reducer handler
const dataTableFilterReducer = (state, action) => {
    //console.log("print out filterReducer", state, action);
    switch (action.type) {
        case "SET_DATA":
            return {
                startIndex: action.startIndex,
                entryPerPage: action.entryPerPage,
                sortingColumn: action.sortingColumn,
                sortingOrder: action.sortingOrder,
                searchTerm: action.searchTerm
            };
        case "SORT":
            return {
                ...state,
                sortingColumn: action.sortingColumn,
                sortingOrder: action.sortingOrder
            };
        case "ENTRY_PER_PAGE":
            return {
                ...state,
                entryPerPage: action.entryPerPage,
            };
        case "PAGINATION":
            return {
                ...state,
                startIndex: action.startIndex
            };
        case "SEARCH":
            return {
                ...state,
                searchTerm: action.searchTerm
            }
    }
}

const DatatableBaseStatic = ({ ...props }) => {

    const loginState = store.getState().loginInfo;
    //let location = useLocation();
    //var passedData = location.state;

    //const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);

    //console.log("PROPS");
    //console.log(props);
    //console.log(passedData);

    const dispatch = useDispatch();

    const searchFieldText = props.searchFieldText;

    //const organizationListSortId = props.sortColumn;//"0";
    //const organizationListSortAsc = props.sortDirection;//false;

    const [currentPage, setCurrentPage] = useState(1);
    const [isDataListPending, setIsDataListPending] = useState(true);
    const [data, setData] = useState([]);
    const [recordsTotal, setRecordsTotal] = useState(0);


    var reload = false;
    if (isInObject("reload", props) && props.reload != null) {
        reload = props.reload;
    }

    const [paginationControlValues, setPaginationControlValues] = useState({
        total: 0,
        rangeStart: 0,
        rangeEnd: 0
    });


    const sortingColumn = () => {
        if ('sortingColumn' in props) {
            return props.sortingColumn;
        }
        else {
            return '';
        }
    }
    const sortingOrder = () => {
        if ('sortingOrder' in props) {
            return props.sortingOrder;
        }
        else {
            return '';
        }
    }

    const striped = () => {
        if ('striped' in props) {
            return props.striped;
        }
        else {
            return true;
        }
    }

    const passedFilter = () => {
        //console.log("PROPS");
        //console.log(props);
        //console.log(props.filter);
        if ('filter' in props && props.filter != null) {
            //console.log(props.filter);
            return props.filter;
        }
        else {
            return {
                startIndex: 0,
                entryPerPage: 10,
                sortingColumn: sortingColumn(),
                sortingOrder: sortingOrder(),
                searchTerm: ""
            };
        }
    }

    const passedExtraFilter = () => {
        //console.log("PROPS");
        //console.log(props);
        //console.log(props.extraFilter);
        if ('extraFilter' in props && props.extraFilter != null) {
            //console.log(props.extraFilter);
            return props.extraFilter;
        }
        else {
            return {
            };
        }
    }

    useEffect(()=>{
        //console.log("CHANGED");
        //console.log(props.extraFilter);
        loadData();

    },[props.extraFilter])

    const [searchTerm, setSearchTerm] = useState(passedFilter().searchTerm);

    //const [sortColumn, setSortColumn] = useState(sortingColumn());
    //const [sortOrder, setSortOrder] = useState(sortingOrder());

    const [datatableFilter, datatableFilterDispatch] = useReducer(dataTableFilterReducer, passedFilter());
    //const [extraFilter, extraFilterDispatch] = useReducer(props.extraFilterReducer, passedExtraFilter());

    const [selectedList, setSelectedList] = useState({
        allSelected: false,
        selectedCount: 0,
        selectedRows: []
    });
    const [sortingInfo, setSortingInfo] = useState({
        sortingColumn: sortingColumn(),
        sortingOrder: sortingOrder()
    })
    const dataColumns = props.getListCols([], sortingInfo, setSortingInfo);
    const [toggledClearRows, setToggleClearRows] = useState(false);

    const handleClearRows = () => {
        setToggleClearRows(!toggledClearRows);
    }
    const rowDisabledCriteria = row => {
        if (isInObject("rowDisabledCriteria", props)) {
            return props.rowDisabledCriteria(row);
        }
        else {
            return null;
        }
    }

    /*const setGlobalStatus = (errorMessage) => {
        //console.log("Error caught while loading data: " + errorMessage);
        dispatch(setStatus(STATUSES.ERROR));
        dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: errorMessage, showContactHelp: true }));
        dispatch(setRedirect({redirect: false, path: "", redirectData:{}}));
    }*/

    const setInitialSearchText = (filter) => {
        setCurrentPage(1);
        datatableFilterDispatch({
            type: "SEARCH",
            searchTerm: filter.searchTerm
        })
        handlePageChange(1);
    }



    // Load organization list data
    const loadData = async () => {
        //console.log();
        var l = props.getData.length;
        var func = null;
        if(l==2){
            func = props.getData(datatableFilter,passedExtraFilter());
        }
        else{
            func = props.getData(datatableFilter);
        }
        

        await func.then((res) => {
            //console.log("getDATA ", res);
            if(props.hasOwnProperty("setApiData")){
                props.setApiData(res);
            }

            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;
                if (isInObject("dataPath", props) && props.dataPath != null) {
                    d = d[props.dataPath];
                    //console.log(d);
                }
                setData(d.entryList);
                setRecordsTotal(d.totalCount);

                setPaginationControlValues({
                    total: d.totalCount,
                    rangeStart: (datatableFilter.entryPerPage * (d.loadedPage - 1)) + 1,
                    rangeEnd: (datatableFilter.entryPerPage * (d.loadedPage - 1)) + d.entryList.length
                });
                setSelectedList({
                    allSelected: false,
                    selectedCount: 0,
                    selectedRows: []
                });
                setCurrentPage(d.loadedPage);
                if (isInObject("setFilter", props) && props.setFilter != null) {
                    props.setFilter(datatableFilter);
                }
            }

            setIsDataListPending(false);
            setSortingInfo({ sortingColumn: datatableFilter.sortingColumn, sortingOrder: datatableFilter.sortingOrder })
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);
            setIsDataListPending(false);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
    };


    useEffect(() => {
        //console.log("PASSEDFILTER");
        //console.log(passedFilter());
        setSortingInfo({ sortingColumn: passedFilter.sortingColumn, sortingOrder: passedFilter.sortingOrder })
        //loadData();
        //listFilterChange(passedFilter());

        //console.log(datatableFilter);
        //setInitialSearchText(passedFilter());
    }, [])

    /*useEffect(() => {
        //console.log("CHANGEDFILTER");
        setSortingInfo({sortingColumn: passedFilter.sortingColumn, sortingOrder:passedFilter.sortingOrder})
        //loadData();
        listFilterChange(passedFilter());
        
        //console.log(datatableFilter);
        //setInitialSearchText(passedFilter());
    },[])*/

    // RDTC data table filter:  datatableFilter
    const listFilterChange = (filter) => {
        //console.log("listFilterChange", filter);
        //setSortColumn(filter.sortingColumn);
        //setSortOrder(filter.sortingOrder);
        datatableFilterDispatch({
            type: "SET_DATA",
            startIndex: filter.startIndex,
            entryPerPage: filter.entryPerPage,
            sortingColumn: filter.sortingColumn,
            sortingOrder: filter.sortingOrder,
            searchTerm: filter.searchTerm
        })
    }

    //Handle column sort event
    const handleSort = (column, sortDirection) => {
        //console.log("handleSort" + column.sortColumnName + " " + sortDirection);
        //setSortColumn(column.sortColumnName);
        //setSortOrder(sortDirection);
        datatableFilterDispatch({
            type: "SORT",
            sortingOrder: sortDirection,
            sortingColumn: column.sortColumnName
        })
        handlePageChange(1);
    }

    // Entry per page of the datatable filter
    const handlePerRowsChange = (newPerPage) => {
        //console.log("handlePerRowsChange", newPerPage);
        datatableFilterDispatch({
            type: "ENTRY_PER_PAGE",
            entryPerPage: newPerPage
        })
    }

    // Page change: last, next, first, last
    const handlePageChange = (page) => {
        //console.log("handlePageChange", page);
        if (isDataListPending != true) {
            let index = datatableFilter.entryPerPage * (page - 1)

            setCurrentPage(page);
            datatableFilterDispatch({
                type: "PAGINATION",
                startIndex: index
            })
        }
    };

    const handleSelectedRowsChange = (sRows) => {
        //console.log("Selected Rows: ", sRows);
        setSelectedList(sRows);
    }

    // Search Text of the datatable filter
    const handleSearchText = (e) => {
        //console.log("handleSearchText", e.target.value);
        setCurrentPage(1);

        datatableFilterDispatch({
            type: "SEARCH",
            searchTerm: e.target.value
        })
        handlePageChange(1);

    }



    const handlePageRowsChange = (e) => {
        //console.log("handlePageRowsChange", e.target.value);

        datatableFilterDispatch({
            type: "ENTRY_PER_PAGE",
            entryPerPage: e.target.value
        })
        handlePageChange(1);
    }

    useEffect(() => {
        if (isInObject("setSelected", props) && props.setSelected != null) {
            props.setSelected(selectedList);
        }

    }, [selectedList])

    var numPages = Math.ceil(recordsTotal / datatableFilter.entryPerPage);
    var numPagesArr = [];
    for (var x = 2; x < numPages; x++) {
        numPagesArr.push(x);
    }



    useEffect(() => {
        if ((isInObject("setReload", props) && isInObject("reload", props)) && (props.setReload != null && props.reload != null)) {
            if(props.reload==true){
                handleClearRows();
                //loadData();
                props.setReload(false);
                handlePageChange(1);
            }
            
        }
        
    }, [reload]);

    useEffect(() => {
        //setSearchTerm(datatableFilter.searchTerm);
        handleClearRows();

        //loadData();
        if ((isInObject("setReload", props) && isInObject("reload", props)) && (props.setReload != null && props.reload != null)) {
            props.setReload(false);
        }
    }, [datatableFilter]);


    //useEffect(() => {
        //setSearchTerm(datatableFilter.searchTerm);
        //handleClearRows();
        //console.log(extraFilter);
        //loadData();
        /*if ((isInObject("setReload", props) && isInObject("reload", props)) && (props.setReload != null && props.reload != null)) {
            props.setReload(false);
        }*/
    //}, [extraFilter]);



    const ExpandedComponent = ({ data }) => {
        return (<div className="rdt_TableCell">{JSON.stringify(data, null, 2)}</div>);
    };

    return (
        <>
            <div className="outlinedContent" >
                {props.displayChildren == true
                    ?
                        <Row className="ps-3 pe-3 mb-4 table-action-buttons-container">
                            {props.children}
                        </Row>

                    : null
                }



                {
                    props.datatableHeader != null
                        ? <h2 className="datatable-title">{props.datatableHeader}</h2>
                        : null
                }
                {
                    props.datatableDescription != null
                        ? <p className="text-center datatable-description">{props.datatableDescription}</p>
                        : null
                }

                <DataTable
                    /*expandableRows={true}
                    expandableRowsComponent={ExpandedComponent}
                    expandOnRowClicked={true}
                    expandOnRowDoubleClicked={false}
                    expandableRowsHideExpander={false}*/


                    clearSelectedRows={toggledClearRows}

                    className={props.tableClassName + " static_datatable"}
                    persistTableHead={true}
                    columns={dataColumns}
                    data={data}
                    progressPending={isDataListPending}
                    customStyles={DATATABLE_CUSTOM_STYLES_STATIC}
                    striped={striped()}
                    ///sortingColumn:,
                    //sortingOrder:,

                    defaultSortFieldId={sortingInfo.sortingColumn}
                    defaultSortAsc={sortingInfo.sortingOrder == "asc" ? true : false}

                    datatableFilterChange={listFilterChange}
                    onSort={handleSort}
                    sortServer
                    paginationServer
                    rowSelection={selectedList}
                    paginationTotalRows={recordsTotal}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    paginationPerPage={datatableFilter.length}
                    sortColumnChange={handleSort}
                    noDataFoundDesc={NO_DATA_FOUND_DESCRIPTION}
                    noDataComponent={<p className="no-data-comp">{NO_DATA_FOUND_DESCRIPTION}</p>}
                    selectableRows={props.hasSelectableRows}
                    selectableRowsHighlight={true}
                    selectableRowDisabled={rowDisabledCriteria}
                    onSelectedRowsChange={handleSelectedRowsChange}
                    progressComponent={<Spinner variant="table-load-spinner" size="lg" animation="border" className="justify-self-center align-self-center m-4" />}
                />
            </div>


        </>
    );
}

export default DatatableBaseStatic;